import React from "react";
import ReactPlayer from "react-player";
import hotTopic_img from "../../assets/media/fire.png";
import Firebase from "../../firebasehelper";
import { getYoutubeId } from "../../Utils/utils";
import {
  IMAGE_UPLOAD,
  GIF_UPLOAD,
  VIDEO_UPLOAD,
  YOUTUBE_URL,
} from "../../Constants/types";
import "./index.css";
const TopicCard = (props) => {
  return (
    <div className="hotTopic-card">
      <p className="hotTopic-item-title">{props.item.title}</p>
      {(props.item.media_type === IMAGE_UPLOAD ||
        props.item.media_type === GIF_UPLOAD) && (
        <div
          style={{ backgroundImage: `url(${props.item.media_url})` }}
          className="background"
        >
          <img src={hotTopic_img} width="30" style={{ margin: 5 }} />
        </div>
      )}
      {props.item.media_type === VIDEO_UPLOAD && (
        <div className="player-container">
          <ReactPlayer
            url={props.item.media_url}
            width="100%"
            height="100%"
            controls={true}
          />
          <img src={hotTopic_img} width="30" style={{ margin: 5 }} />
        </div>
      )}
      {props.item.media_type === YOUTUBE_URL && (
        <div style={{ position: "relative" }}>
          <iframe
            title="video"
            width="300"
            height="150"
            src={`//www.youtube.com/embed/${getYoutubeId(
              props.item.media_url
            )}?modestbranding=1&showinfo=0`}
            frameBorder="0"
            allowFullScreen
          ></iframe>
          <img src={hotTopic_img} width="30" style={{ margin: 5 }} />
        </div>
      )}
      <div className="card-content">
        <p className="hotTopic-item-time">
          Start from{" "}
          {(Firebase.isObjectTimestamp(props.item.starting_monday)
            ? props.item.starting_monday.toDate()
            : props.item.starting_monday
          ).toLocaleDateString("en-US", {
            weekday: "long",
            month: "long",
            day: "numeric",
          })}
        </p>
        <p className="hotTopic-item-description">{props.item.description}</p>
      </div>
      {/* <p className="hotTopic-item-title">{props.item.tag}</p> */}
    </div>
  );
};
export default TopicCard;



// WEBPACK FOOTER //
// ./src/screens/HotTopic/TopicCard.js